import { IModalConfiguration } from '@ispm/shared/interfaces/action.interface';

export class ButtonAction {
  constructor(
    public label: string,
    public command: () => void,
    public modalConfig?: IModalConfiguration,
    public requiredPermission?:string,
  ) {
  }


}
